// Moje odměna pro sales (mockup v8, obrazovka 12): hodiny z Time reportu krát sazba
// a sales bonusy za klientky po zkušebním (schvaluje owner v HR, Bonusy a srážky).
// 1. 10. 2026 (mockup „Moje odměna sales“, schváleno): Moje výplata se sem sloučila.
// Schválený měsíc bere čísla z HR výplat (stejná jako owner schválil), běžící měsíc
// je průběžný odhad jako dřív.
import React, { useEffect, useState } from "react";
import { Wallet, User } from "lucide-react";
import { ListovaniMesice, Dlazdice } from "../ui.jsx";
import { apiFetch } from "../../lib/api.js";
import { getRealUser, getViewAsRole } from "../../lib/auth.js";
import { salesGet, dm } from "./salesApi.js";
import { KartaLista, RadekShrnuti, SkupinaNadpis, Pil, Oznameni } from "./salesUi.jsx";

const MESICE = ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"];
const MESICE_2 = ["lednu", "únoru", "březnu", "dubnu", "květnu", "červnu", "červenci", "srpnu", "září", "říjnu", "listopadu", "prosinci"];
const kc = (n) => `${Math.round(Number(n) || 0).toLocaleString("cs-CZ")} Kč`;
const hod = (n) => `${String(Math.round((Number(n) || 0) * 10) / 10).replace(".", ",")} h`;
const STAV = {
  splneno_caka_schvaleni: ["pozor", "čeká na schválení"], caka_vyplaceni: ["ok", "schváleno"], vyplacen: ["ok", "vyplaceno"], caka_splneni: ["neutralni", "čeká"],
};
function posunMesic(m, o) { const [y, mm] = m.split("-").map(Number); const d = new Date(Date.UTC(y, mm - 1 + o, 1)); return d.toISOString().substring(0, 7); }

async function nactiVyplatu(mesic) {
  const p = new URLSearchParams({ self: "1", mesic });
  // Owner v náhledu sales: backend dohledá osobu podle role (stejně jako Moje výplata).
  if (getRealUser()?.role === "owner") { const n = getViewAsRole(); if (n) p.set("viewRole", n); }
  try {
    const r = await apiFetch(`/api/hr-vyplaty?${p.toString()}`);
    const j = await r.json();
    return j?.ok ? j : null;
  } catch { return null; }
}

export default function MojeOdmena() {
  const dnes = new Date().toISOString().substring(0, 7);
  const [mesic, setMesic] = useState(dnes);
  const [d, setD] = useState(null);
  const [v, setV] = useState(null);
  const [nejstarsi, setNejstarsi] = useState(dnes);
  const [chyba, setChyba] = useState("");
  useEffect(() => {
    let zive = true;
    setD(null); setV(null); setChyba("");
    Promise.all([salesGet("odmena", { mesic }), nactiVyplatu(mesic)])
      .then(([o, vy]) => {
        if (!zive) return;
        setD(o); setV(vy);
        const sm = vy?.schvaleneMesice || [];
        if (sm.length) setNejstarsi((x) => (sm[sm.length - 1] < x ? sm[sm.length - 1] : x));
      })
      .catch((e) => { if (zive) setChyba(e.message); });
    return () => { zive = false; };
  }, [mesic]);
  const [y, m] = mesic.split("-").map(Number);
  const schvaleno = !!(v?.schvaleno && v?.row);
  const nazevMesice = `${MESICE[m - 1].replace(/^./, (c) => c.toUpperCase())} ${y}`;
  const popisMesice = d ? (
    <span className="flex items-center gap-2">{nazevMesice}<Pil ton={schvaleno ? "ok" : "pozor"} casti={schvaleno ? "Schváleno" : "Průběžně"} /></span>
  ) : nazevMesice;

  return (
    <KartaLista ikona={Wallet} nazev="Moje odměna">
      <div className="space-y-4">
        <ListovaniMesice popis={popisMesice} onZpet={() => setMesic(posunMesic(mesic, -1))} onVpred={() => setMesic(posunMesic(mesic, 1))}
          zpetVypnuto={mesic <= nejstarsi} vpredVypnuto={mesic >= dnes} />
        {chyba && <Oznameni ton="problem">{chyba}</Oznameni>}
        {!d ? <div className="h-32 animate-pulse rounded-xl bg-brand-light" /> : schvaleno ? <Schvaleno v={v} m={m} /> : <Prubezne d={d} m={m} />}
      </div>
    </KartaLista>
  );
}

// Schválený měsíc: přesně čísla z HR výplat (self view, bez soukromých položek).
function Schvaleno({ v, m }) {
  const r = v.row;
  const rozpad = Array.isArray(r.hodiny_rozpad) ? r.hodiny_rozpad : [];
  const hodiny = rozpad.reduce((s, h) => s + (Number(h.hours) || 0), 0);
  const bonusy = v.detail?.bonusItems || [];
  const srazky = Number(r.srazky) || 0;
  const odecty = v.odecty_verejne || [];
  const celkem = r.k_fakturaci != null ? r.k_fakturaci : r.celkem;
  return (
    <>
      <div className="grid grid-cols-2 gap-2 sm:gap-3">
        <Dlazdice popisek="Hodiny" hodnota={hod(hodiny)} ton="info" />
        <Dlazdice popisek="Bonusy" hodnota={kc(r.bonusy)} ton="ok" />
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white px-4 py-1">
        {rozpad.map((h, i) => (
          <RadekShrnuti key={i} popisek={`${rozpad.length > 1 ? `${h.oblast || "Hodiny"}, ` : "Hodiny, "}${String(h.hours || 0).replace(".", ",")} × ${kc(h.rate)}`}><span className="whitespace-nowrap">{kc(h.castka)}</span></RadekShrnuti>
        ))}
        {r.fix && <RadekShrnuti popisek="Fixní odměna"><span className="whitespace-nowrap">{kc(r.zakladni_castka)}</span></RadekShrnuti>}
        <RadekShrnuti popisek="Bonusy"><span className="whitespace-nowrap">{kc(r.bonusy)}</span></RadekShrnuti>
        {srazky > 0 && <RadekShrnuti popisek="Srážky"><span className="whitespace-nowrap">−{kc(srazky)}</span></RadekShrnuti>}
        {odecty.map((o, i) => <RadekShrnuti key={`o${i}`} popisek={o.popis || "Odečet"}><span className="whitespace-nowrap">−{kc(o.castka)}</span></RadekShrnuti>)}
        <div className="flex items-center justify-between gap-4 border-t border-slate-200 py-3">
          <span className="text-[15px] font-bold text-slate-900">K výplatě za {MESICE[m - 1]}</span>
          <span className="whitespace-nowrap font-serif text-2xl font-bold text-brand-deep">{kc(celkem)}</span>
        </div>
      </div>
      {bonusy.length > 0 && (
        <>
          <SkupinaNadpis>Bonusy</SkupinaNadpis>
          <div className="space-y-2">
            {bonusy.map((b, i) => (
              <div key={i} className="polozka flex items-center justify-between gap-3">
                {/* 3. 11. 2026: název bez jména klientky (do faktury), klientka zvlášť v pilulce. */}
                <div className="min-w-0">
                  <div className="text-[15px] font-bold text-slate-900">{b.popis || "Bonus"}</div>
                  {b.klient && <div className="mt-1 flex flex-wrap gap-1.5 select-none"><Pil ton="neutralni" ikona={User} casti={b.klient} /></div>}
                </div>
                <span className="whitespace-nowrap text-[15px] font-bold tabular-nums text-emerald-700">+{kc(b.castka)}</span>
              </div>
            ))}
          </div>
        </>
      )}
      <Oznameni ton="ok">Schváleno. Vyplácí se podle smlouvy.</Oznameni>
    </>
  );
}

// Běžící (neschválený) měsíc: průběžný odhad z Time reportu a sales bonusů.
function Prubezne({ d, m }) {
  return (
    <>
      <div className="grid grid-cols-2 gap-2 sm:gap-3">
        <Dlazdice popisek="Hodiny" hodnota={`${d.hodiny} h`} ton="info" />
        <Dlazdice popisek="Nové klientky" hodnota={d.bonusy.length} ton="ok" />
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white px-4 py-1">
        <RadekShrnuti popisek={`Hodiny, ${d.hodiny} × ${kc(d.hodinova)}`}><span className="whitespace-nowrap">{kc(d.castkaHodiny)}</span></RadekShrnuti>
        <RadekShrnuti popisek="Bonus, schválené"><span className="whitespace-nowrap">{kc(d.castkaBonus)}</span></RadekShrnuti>
        <div className="flex items-center justify-between gap-4 border-t border-slate-200 py-3">
          <span className="text-[15px] font-bold text-slate-900">Zatím za {MESICE[m - 1]}</span>
          <span className="whitespace-nowrap font-serif text-2xl font-bold text-brand-deep">{kc(d.celkem)}</span>
        </div>
        {d.ceka > 0 && <div className="border-t border-slate-100 py-2.5 text-[13px] text-slate-500">Dalších {kc(d.ceka)} v bonusech čeká na schválení.</div>}
      </div>
      <SkupinaNadpis>Bonus, nové klientky</SkupinaNadpis>
      {d.bonusy.length ? (
        <div className="space-y-2">
          {d.bonusy.map((b) => (
            <div key={b.id} className="polozka flex items-center justify-between gap-3">
              <div className="min-w-0">
                <div className="text-[15px] font-bold text-slate-900">{b.klientka}</div>
                <div className="mt-1 flex flex-wrap gap-1.5"><Pil ton="neutralni" casti={dm(b.datum)} /><Pil ton={(STAV[b.stav] || ["neutralni"])[0]} casti={(STAV[b.stav] || ["", b.stav])[1]} /></div>
              </div>
              <span className="whitespace-nowrap text-[15px] font-bold tabular-nums text-emerald-700">+{kc(b.castka)}</span>
            </div>
          ))}
        </div>
      ) : <div className="text-sm text-slate-500">V tomhle měsíci zatím žádný bonus.</div>}
      <Oznameni ton="znacka">Průběžný odhad za {MESICE_2[m - 1]}. Konečnou částku uvidíš, až Láďa měsíc schválí. Bonus vznikne sám, když klientka po tvém zkušebním tréninku zaplatí první fakturu za spolupráci.</Oznameni>
    </>
  );
}
